<template>
  <div class="row">
    <div class="col-md-12">
      <div class="panel">
        <div class="panel-body">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group text-center">
                <img
                  v-if="previewImage"
                  :src="previewImage"
                  class="photo"
                  alt="Prévia da foto de perfil"
                >
                <img
                  v-else-if="profilePhoto && !photoLoadError"
                  :src="profilePhoto"
                  class="photo"
                  alt="Foto de perfil"
                  @error="photoLoadError = true"
                >
                <i
                  v-else
                  class="fa fa-user-circle avatar-placeholder"
                />
              </div>
              <div class="profile_user">
                <h3 class="user_name_max">
                  {{ user.name }}
                </h3>
                <hr class="hr">
              </div>
            </div>

            <div class="col-md-12">
              <div class="row">
                <div
                  v-show="user.name"
                  class="col-md-6"
                >
                  <label>Nome</label>
                  <input
                    v-model="user.name"
                    type="text"
                    class="form-control"
                    readonly
                  >
                </div>

                <div
                  v-show="user.email"
                  class="col-md-6"
                >
                  <label>E-mail</label>
                  <input
                    v-model="user.email"
                    type="email"
                    class="form-control"
                    readonly
                  >
                </div>
              </div>

              <button
                type="button"
                class="btn btn-secondary mt-2"
                @click="showPasswordModal = true"
              >
                Deseja alterar a senha?
                <i class="fa fa-key" />
              </button>
              <hr>

              <div class="text-right mt-3">
                <button
                  class="btn btn-outline-primary mr-2"
                  @click="$router.push('/')"
                >
                  <i class="fa fa-arrow-left" />
                  Voltar
                </button>
                <button
                  class="btn btn-primary"
                  @click="save"
                >
                  Salvar
                  <i class="fa fa-save" />
                </button>

              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal
        v-model="showPasswordModal"
        title="Digite a nova Senha"
        hide-footer
        centered
      >
        <div class="form-group text-left">
          <label>Senha atual <span class="required">*</span></label>

          <div class="input-group">
            <input
              v-model="passwordForm.current_password"
              :type="currentPasswordFieldType"
              class="form-control"
            >

            <div class="input-group-append">
              <button
                type="button"
                class="btn btn-outline-secondary"
                @click="toggleCurrentPasswordVisibility"
              >
                <i :class="currentPasswordFieldType === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash'" />
              </button>
            </div>
          </div>
        </div>

        <div class="form-group text-left">
          <label>Nova Senha <span class="required">*</span></label>

          <div class="input-group">
            <input
              v-model="passwordForm.password"
              :type="newPasswordFieldType"
              class="form-control"
            >

            <div class="input-group-append">
              <button
                type="button"
                class="btn btn-outline-secondary"
                @click="toggleNewPasswordVisibility"
              >
                <i :class="newPasswordFieldType === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash'" />
              </button>
            </div>
          </div>
        </div>

        <div class="form-group text-left">
          <label>Confirmar Senha <span class="required">*</span></label>

          <div class="input-group">
            <input
              v-model="passwordForm.password_confirmation"
              :type="confirmPasswordFieldType"
              class="form-control"
            >

            <div class="input-group-append">
              <button
                type="button"
                class="btn btn-outline-secondary"
                @click="toggleConfirmPasswordVisibility"
              >
                <i :class="confirmPasswordFieldType === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash'" />
              </button>
            </div>
          </div>
        </div>

        <div class="text-right mt-3">
          <button
            type="button"
            class="btn btn-outline-primary mr-2"
            @click="closePasswordModal"
          >
            <i class="text" />
            Cancelar
          </button>

          <button
            type="button"
            class="btn btn-primary"
            @click="changePassword"
          >
            Salvar
            <i class="fa fa-save" />
          </button>
        </div>
      </b-modal>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: {
        id: 0,
        name: '',
        email: '',
        picture: '',
        photo: '',
      },

      previewImage: '',
      selectedPhoto: null,
      photoLoadError: false,

      showPasswordModal: false,

      passwordForm: {
        current_password: '',
        password: '',
        password_confirmation: '',
      },

      passwordErrors: {},

      currentPasswordFieldType: 'password',
      newPasswordFieldType: 'password',
      confirmPasswordFieldType: 'password',
    }
  },
  computed: {
    profilePhoto() {
      return this.user.photo || this.user.picture
    },
  },
  mounted() {
    this.user = this.$store.state.user
    console.log(this.user)
  },
  beforeDestroy() {
    this.revokePreviewImage()
  },
  methods: {
    revokePreviewImage() {
      if (this.previewImage) {
        URL.revokeObjectURL(this.previewImage)
      }
    },
    previewPhoto(event) {
      const file = event.target.files[0]

      if (!file) {
        this.previewImage = ''
        this.selectedPhoto = null
        return
      }

      this.selectedPhoto = file
      this.photoLoadError = false
      this.previewImage = URL.createObjectURL(file)
    },
    save() {
      const self = this
      const api = `${self.$store.getters.api}users/image/update/${self.user.id}`

      if (!self.selectedPhoto) {
        self.$router.push('/').than(() => {
          window.location.reload()
        })
        return
      }

      const data = new FormData()

      data.append('id', self.user.id)
      data.append('photo', self.selectedPhoto)

      axios
        .post(api, data)
        .then(response => {
          self.$message('Sucesso', 'Foto de perfil atualizada!', 'success')

          const photoUrl = `${self.$store.state.url}/user/image/${self.user.id}?${Date.now()}`

          self.user.photo = photoUrl
          self.$store.state.user.photo = photoUrl
          self.$store.state.user.photo_url = photoUrl

          self.revokePreviewImage()
          self.previewImage = ''
          self.selectedPhoto = null

          self.$router.push('/').than(() => {
            window.location.reload()
          })
        })
        .catch(() => {
          // Do nothing
        })

      // this.$router.push('/user');
    },

    toggleCurrentPasswordVisibility() {
      this.currentPasswordFieldType = this.currentPasswordFieldType === 'password' ? 'text' : 'password'
    },

    toggleNewPasswordVisibility() {
      this.newPasswordFieldType = this.newPasswordFieldType === 'password' ? 'text' : 'password'
    },

    toggleConfirmPasswordVisibility() {
      this.confirmPasswordFieldType = this.confirmPasswordFieldType === 'password' ? 'text' : 'password'
    },

    closePasswordModal() {
      this.showPasswordModal = false
      this.passwordForm.current_password = ''
      this.passwordForm.password = ''
      this.passwordForm.password_confirmation = ''
      this.passwordErrors = {}
    },
    changePassword() {
      const self = this
      const api = `${self.$store.getters.api}users/change-password`

      axios
        .post(api, self.passwordForm)
        .then(() => {
          self.closePasswordModal()

          let seconds = 5

          self.$message(
            'Sucesso',
            `Senha alterada com sucesso. Você será desconectado em ${seconds} segundos.`,
            'success',
            null,
            1000,
          )

          const timer = setInterval(() => {
            seconds--

            if (seconds > 0) {
              self.$message(
                'Atenção',
                `Você será desconectado em ${seconds} segundos.`,
                'info',
                null,
                5000,
              )
              return
            }

            clearInterval(timer)

            const logoutApi = `${self.$store.state.api}logout`

            axios
              .post(logoutApi)
              .then(() => {
                localStorage.removeItem('token')
                self.$router.push({ path: '/login' })
              })
              .catch(() => {
                localStorage.removeItem('token')
                self.$router.push({ path: '/login' })
              })
          }, 1000)
        })
        .catch(error => {
          self.$message('Erro', error.response.data, 'error')
          self.passwordErrors = error.response ? error.response.data : {}
        })
    },

    makeid() {
      let text = ''
      const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

      for (let i = 0; i < 5; i++) text += possible.charAt(Math.floor(Math.random() * possible.length))

      return text
    },
  },
}
</script>

<style scoped>
.img-bor {
  width: 150px;
}

.profile_user {
  text-align: center;
}

.photo {
  border-radius: 50%;
  height: 150px;
  object-fit: cover;
  width: 150px;
}

.required {
  color: red;
  line-height: 1;
  margin-bottom: 6px;
}

.avatar-placeholder {
  color: #ccc;
  font-size: 150px;
  line-height: 150px;
}

</style>
